import ClaimTypeRM from '../responsemodel/ClaimTypeRM'
import ClaimType from '../../models/ClaimType'
import DataMapper from './DataMapper'

export default class ClaimTypeDataMapper extends DataMapper<ClaimTypeRM, ClaimType> {
  map = (rm: ClaimTypeRM) => new ClaimType(rm.title, rm.fee, rm.gst_percentage, rm.hsn_code)
}
